import { useQuery } from 'react-query';
import { GET, PUT, getRecaptchaToken } from './http-service';

export const Customer = ({ journeyGuid: journeyGUID, lngCode, rcaEnabled, executeRecaptcha, useMock }) => {
  const baseApi = `${lngCode}/customers`;

  return {
    useCustomerInfoQuery(canUseCustomerData, onSuccess) {
      return useQuery(
        ['active-query', 'customer-info', journeyGUID],
        () => getCustomerInfo(),
        { enabled: canUseCustomerData, staleTime: 60 * 1000, onSuccess: onSuccess }
      );
    },
    async updateCustomerInfo(customerData, hasRecaptcha) {
      if (useMock) {
        return Promise.resolve(() => true)
      }

      const { propertyDataList } = customerData;
      const headers = !!rcaEnabled && hasRecaptcha && { headers: getRecaptchaToken(await executeRecaptcha('details')) };
      return PUT(`${baseApi}`, { identity: journeyGUID, propertyDataList }, headers);
    }
  };

  function getCustomerInfo() {
    if (useMock) {
      return Promise.resolve(() => {
        // dispatch(userDataSet({customerGUID: '00000000-0000-0000-0000-00000000'}))
        return {
          personalId: '1234',
          fullName: 'John Doe',
          customerIdTypeName: 'ID',
          customerIdTypeId: -1,
          details: {
            customerGUID: '00000000-0000-0000-0000-00000000',
            personalId: '1234',
            firstName: 'John',
            lastName: 'Doe',
            pictureAttachmentId: null,
            email: null,
            telNumber1: '+1 (555) 123-4567',
            telNumber2: null,
            notes: null,
            languageCode: 'en',
            dob: null,
            isMemberOfGroups: false,
            isActive: true,
            extRef: null,
            customProperties: [
              {
                propertyId: 2,
                value: 'false'
              },
              {
                propertyId: 7,
                value: '1989-02-06'
              },
              {
                propertyId: 8,
                value: 's'
              }
            ],
            customerIdTypeId: -1,
            customerLevelId: null,
            customerIdTypeName: null,
            gender: 1,
            notificationConsent: 1,
            customerIdType: null,
            customerLevel: null
          }
        }
      })
    }
    return GET(`${baseApi}/${journeyGUID}/info`)
      .then(response => {
        if (!response) return undefined;
        const { personalId, firstName, lastName, customerIdTypeName, customerIdTypeId, customerGUID } = { ...response };

        const fullName = (!!firstName || !!lastName)
          ? [firstName, lastName]
            .filter(Boolean)
            .map(str => str.trim()).join(' ')
          : false;

        return { personalId, fullName, customerIdTypeName, customerIdTypeId, customerGUID, details: { ...response } }
      });
  }
}

